export const FrontendPath ="https://ipff2.bdprescription.com";
//export const FrontendPath ="http://localhost/IPFF2/frontend";
//export const FrontendPath = "http://10.42.140.218:8080/IPFF2/frontend";


// WEBPACK FOOTER //
// ./src/vuex/api.js